
<div class="card-menu-body">
  <div class="sidebar-menu-simpler-topics">
    <ul style="margin-bottom: 0;">
      @for (menu of menusReportagem; track $index) {
          <li
            [id]="menu.topic.replaceAll(' ', '').toLowerCase()"
            [class.selected]="menu.topic === selectedMenuReportagem?.topic"
            tabindex="0"
            (click)="selectTopic(menu.topic)"
            (keyup.enter)="selectTopic(menu.topic)">
            {{ menu.topic }}
          </li>

          <div class="exibe-tela-pequena">
            @if (selectedMenuReportagem?.topic === menu?.topic) {
              <div class="content-area">
                <div class="qa-cards">
                  @for (item of selectedMenuReportagem.reportagens; track item) {            <lib-segov-sigepo-accordeon
                      [customTitleStyle]="'padding-left: 1rem; font-weight: 600; color: var(--tom-2-informativo);'"
                      [customChevronStyle]="'font-size: 24px; color: var(--tom-2-informativo);'"
                      [title]="item.titulo">
                      <button class="btn btn-link card-reportagem" (click)="emitButtonClick(item)">
                        <div class="qa-card">
                          <div class="col m-1 ml-2 ml-sm-0 pb-2 mt-1">
                            <span style="color: var(--secondary-yellow); font-weight: 700; font-size: 16px;">{{ item.dataPublicacaoFormatada }}</span> <br />
                              <span style="color: var(--text-geral-fundo-claro); font-weight: 400;">{{ item.titulo }}</span>
                          </div>
                          <div class="col-1 right-icon">

                          </div>
                        </div>
                      </button>
                    </lib-segov-sigepo-accordeon>
                  }
                </div>
              </div>
            }
          </div>
      }
    </ul>
  </div>

  <div class="content-area exibe-tela-grande">
    @if (selectedMenuReportagem) {
      <div class="content-area">
        <div class="qa-cards">
          @for (item of selectedMenuReportagem.reportagens; track item) {            <lib-segov-sigepo-accordeon
              [customTitleStyle]="'padding-left: 1rem; font-weight: 600; color: var(--tom-2-informativo);'"
              [customChevronStyle]="'font-size: 24px; color: var(--tom-2-informativo);'"
              [title]="item.titulo">
              <button class="btn btn-link card-reportagem" (click)="emitButtonClick(item)">
                <div class="row qa-card">
                  <div class="col m-1 ml-2 ml-sm-0 pb-2 mt-1">
                    <span style="color: var(--secondary-yellow); font-weight: 700; font-size: 16px;">{{ item.dataPublicacaoFormatada }}</span> <br />
                      <span style="color: var(--text-geral-fundo-claro); font-weight: 400;">{{ item.titulo }}</span>
                  </div>
                  <div class="col-1 right-icon" style="align-self: center;">
                    <i class="fas fa-chevron-right" style="font-size: 24px; color: var(--tom-2-informativo);" ></i>
                  </div>
                </div>
              </button>
            </lib-segov-sigepo-accordeon>
          }
        </div>
      </div>
    } @else {
      <p>Por favor, selecione alguma opção.</p>
    }
  </div>
</div>